"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectUndefined = void 0;
const rejectUndefined = (arr) => arr.filter((element) => element !== undefined);
exports.rejectUndefined = rejectUndefined;
//# sourceMappingURL=array_functions.js.map